// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 143) return "static/css/143.d34d7affeacddb3609e3.css";
	if (chunkId === 7564) return "static/css/sender.0981ab9c21a7515c8483.css";
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"704":"322f1cc3ca0f05a8be68","1412":"83971b4df2c901ec0bdb","1896":"0981ab9c21a7515c8483","4219":"1522f7b39539371e720d","4514":"1522f7b39539371e720d","6877":"322f1cc3ca0f05a8be68","6952":"322f1cc3ca0f05a8be68","8107":"a1717806cb26dd0b7c20","9010":"1522f7b39539371e720d"}[chunkId] + ".chunk.css";
};